import React from 'react';
import { useTranslation } from 'react-i18next';

import { X } from 'lucide-react';

import { useAppDispatch, useAppSelector } from '../../hooks.ts';
import { uiReducer } from '../../store/reducers/ui.reducer.ts';
import { getShowPaywall } from '../../store/selectors/ui.selector.ts';
import { PlansSubscriptions } from '../profile/PlansSubscriptions.tsx';

export const PaywallModal: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(getShowPaywall);
  const { setShowPaywall } = uiReducer.actions;

  if (!isOpen) return null;

  const handleClose = () => {
    dispatch(setShowPaywall(false));
  };

  return (
    <div className="fixed inset-0 z-[1300] flex items-center justify-center bg-black/80 p-3 backdrop-blur-sm">
      <div className="relative flex max-h-[calc(100vh-24px)] w-full max-w-[1240px] flex-col overflow-hidden rounded-3xl border border-white/10 bg-[#0a0b0a] shadow-2xl">
        {/* Header */}
        <div className="relative px-6 pt-5 text-center">
          <h2 className="text-2xl font-semibold text-white md:text-[28px]">{t('paywall.title')}</h2>
          <button
            onClick={handleClose}
            aria-label={t('common.close')}
            className="absolute right-4 top-4 rounded-full p-2 text-white/60 transition-colors hover:bg-white/10 hover:text-white md:right-5"
          >
            <X size={22} />
          </button>
        </div>

        {/* Content - reusing PlansSubscriptions */}
        <div className="custom-scrollbar flex-1 overflow-auto">
          <PlansSubscriptions isModal />
        </div>

        {/* Footer */}
        <div className="border-t border-white/10 px-6 py-2.5 text-center">
          <p className="text-xs text-white/50 md:text-sm">{t('paywall.footer')}</p>
        </div>
      </div>
    </div>
  );
};
